var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "address-section d-flex flex-column gr-6",
      class: _vm.isMobile ? "" : "pa-6 elevation-1 rounded-sm",
      attrs: { "data-qa": "document_address_section" },
    },
    [
      _vm.companyCardHref && !_vm.isMobile
        ? _c(
            "div",
            { staticClass: "d-flex justify-space-between align-center ga-4" },
            [
              _c(
                "h2",
                {
                  staticClass: "text-h6 text--text ma-0",
                  attrs: { "data-qa": "document_address_title" },
                },
                [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
              ),
              _vm._v(" "),
              _c(_setup.DocumentDownloadLink, {
                attrs: {
                  href: _vm.companyCardHref,
                  label: _setup.t("Скачать карточку компании", _setup.options),
                },
              }),
            ],
            1
          )
        : _c(
            "h2",
            {
              staticClass: "text-h6 text--text ma-0",
              attrs: { "data-qa": "document_address_title" },
            },
            [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
          ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "address-section__list text-body-2 ma-0 pa-0",
          attrs: { "data-qa": "document_address_list" },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "li",
            {
              key: `${String(item)}-${index}`,
              staticClass: "address-section__item mb-3",
              attrs: { "data-qa": "document_address_item" },
            },
            [
              typeof item === "string"
                ? [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                : item.type === "address"
                ? [
                    _vm._v(
                      "\n        " +
                        _vm._s(item.prefix) +
                        "\n        " +
                        _vm._s(
                          _setup.formatCompanyAddress(
                            _vm.physicalAddress,
                            item.variant
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                : item.type === "update"
                ? [
                    _vm._v("\n        " + _vm._s(item.text) + "\n        "),
                    _vm._l(item.links, function (link, linkIndex) {
                      return [
                        linkIndex > 0
                          ? _c("span", { key: `sep-${link.href}` }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_setup.t("и", _setup.options)) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            key: link.href,
                            staticClass:
                              "link-decoration-underline primary--text",
                            attrs: {
                              href: link.href,
                              "data-qa": "document_address_update_link",
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(link.label) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    }),
                    _vm._v("\n        " + _vm._s(item.suffix) + "\n      "),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.headOfficeHref
        ? _c(
            "a",
            {
              staticClass: "link-decoration-underline primary--text",
              attrs: {
                href: _vm.headOfficeHref,
                "data-qa": "document_address_head_office_link",
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.t(
                      "Перейти к реквизитам головной компании",
                      _setup.options
                    )
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }